<template>
  <div class="w-full">
    <div class="w-full max-display-card">
      <div class="text-center font-bold text-4xl px-10 leading-none">
        <span>How many naan are you going to order with your curry?</span>
      </div>
      <transition-group name="slide-fade1" appear>
        <div :key="1" class="w-full px-20 py-6">
          <div class="w-full flex flex-col">
            <div class="w-full w-full__button-block">
              <button
                v-for="n in 4"
                :key="n"
                class="w-button  rounded-lg my-1 mx-1 py-2 font-medium text-regal-gray "
                @click="$emit('naanAmountToOrder', n)"
              >
                <span>{{ n }}</span>
              </button>
            </div>
            <div>
              <button
                class="w-button-l w-full rounded-lg my-1 mx-1 py-2 font-medium text-regal-gray"
                @click="$emit('naanAmountToOrder', 5)"
              >
                5+
              </button>
            </div>
          </div>
        </div>
        <div :key="2" class="w-full max-display flex justify-center">
          <mark-svg/>
        </div>
      </transition-group>
    </div>
    <x-footer />
  </div>
</template>
<script>
import XFooter from "@/components/Footer/XFooter";
import MarkSvg from "@/components/ImageSvg/MarkSvg";

export default {
  name: "OrderNaanComponent",
  components: {
    XFooter,
    MarkSvg
  }
};
</script>
<style scoped>
.w-button {
  width: calc(50% - 8px);
}

.w-button-l {
  width: calc(100% - 8px);
}

.w-full__button-block {
  max-width: 410px;
  margin: 0 auto;
}
</style>
